import { render, staticRenderFns } from "./TableCopies.vue?vue&type=template&id=0945aeef&"
import script from "./TableCopies.vue?vue&type=script&lang=js&"
export * from "./TableCopies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0945aeef')) {
      api.createRecord('0945aeef', component.options)
    } else {
      api.reload('0945aeef', component.options)
    }
    module.hot.accept("./TableCopies.vue?vue&type=template&id=0945aeef&", function () {
      api.rerender('0945aeef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/components/TableCopies.vue"
export default component.exports